<template lang='pug'>
#section4
	#section4-anchor
	.image-section
		img.pattern(src='@/assets/waves1.svg')
		img.image(src='@/assets/images/slide.png')
	.content-section
		.header
			h2 Miðakaup
			img.underline(src='@/assets/blue_wave.svg')
		.paragraph
			p Opnaðu Aur appið
			p Veldu Klink í stikunni neðst á skjánum
			p Veldu "Sápuboltinn 2024"
			p Veldu hvernig týpu af miða þú vilt kaupa (Helgarpassi eða laugardagspassi)
			p Þegar þú klárar kaupin birtist miðinn þinn í Hólfinu í Aur

		//- .button(@click='openLink("https://www.tix.is/sapuboltinn")') Skrá lið
	.additional
		.underline
		p *Með fyrirvara um breytingar

</template>

<script>
export default {
	name: 'Section4',
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		},
		openLink: function (target) {
			window.open(target, '_blank').focus();
		}
	}
};
</script>

<style lang="less" scoped>
#section4 {
	#section4-anchor {
		width: 100vw;
		height: 5px;
		position: absolute;
		top: -100px;
	}
	position: relative;
	margin-top: 200px;
	transform: translateY(-150px);
	display: grid;
	grid-template-columns: 1fr 1fr;
	@media screen and (max-width: 1439px) {
		grid-template-columns: 1fr;
	}
	.additional {
    margin-top: 110px;
		.underline {
			width: 100%;
			max-width: 300px;
			height: 3px;
			background-color: #f3736b;
		}
		a {
			color: #f3736b;
			text-decoration: none;
			font-weight: bold;
			transition: .3s;
			border-radius: 10px;
			&:hover {
				padding-left: 5px;
				padding-right: 5px;
				background-color: white;
			}
		}
		margin-left: 90px;
		margin-right: 167px;
		/*padding-bottom: 48px;*/
		/*color: #f6e0d6;*/
		@media screen and (max-width: 1200px) {
			margin-left: 71px;
			margin-right: 71px;
		}
		@media screen and (max-width: 530px) {
			margin-left: 31px;
			margin-right: 31px;
		}
	}
	.content-section {
		@media screen and (max-width: 1439px) {
			position: relative;
			top: 50px;
			margin-left: auto;
			margin-right: auto;
		}
		@media screen and (max-width: 475px) {
			padding-left: 30px;
			padding-right: 30px;
		}
		.header {
			h2 {
				font-size: 40px;
				color: #f3736b;
				font-weight: bold;
				@media screen and (max-width: 870px) {
					font-size: 31px;
				}
			}
			.underline {
				transform: translateY(-20px);
			}
		}
		.paragraph {
			p {
				transform: translateY(-10px);
				margin-top: 0px;
				max-width: 426px;
				line-height: 1.94;
				font-size: 18px;
				margin-left: 78px;
				@media screen and (max-width: 530px) {
					margin-left: 0px;
					font-size: 16px;
				}
			}
		}
		.button {
			margin-left: 78px;
			width: 158px;
			height: 48px;
			border-radius: 24px;
			border: solid 2px #118acd;
			line-height: 48px;
			text-align: center;
			font-size: 21px;
			font-weight: bold;
			transition: .5s;
			cursor: pointer;
			background: url('~@/assets/top.svg');
			background-size: 177px 101px;
			background-position-y: -100px;
			background-repeat: no-repeat;
			&:hover {
				color: white;
				background-position-y: 0px;
			}
			@media screen and (max-width: 530px) {
				margin-left: auto;
				margin-right: auto;
			}
		}
	}
	.image-section {
		.image {
			position: absolute;
			width: 640px;
			/*height: 323px;*/
			left: 117px;
			top: 96px;
		}
		@media screen and (max-width: 1439px) {
			.pattern {
				position: absolute;
			}
			.image {
				position: relative;
				width: 640px;
				/*height: 323px;*/
				left: 50%;
				transform: translateX(-50%);
				top: 46px;
			}
		}
		@media screen and (max-width: 640px) {
			.image {

				width: 100%;
				height: auto;
			}
		}
	}
}
</style>
